import React from 'react'

const AltTextAudit = props => {

    const genTableBody = () => {
        return props.images.filter(el=> el.src).map((el, i) => {
            return (
                <tr key={`image-${i}`}>
                    <td>
                        <img src={el.src} alt={el.alt} width={'200px'}/>
                    </td>
                    <td>
                        <textarea value={el.alt} onChange={(e)=>{props.handleFormChange([...props.breadcrumbs, ...el.keys, 'alt'], e.currentTarget.value.replace(/[^a-zA-Z0-9,. ]/g, ""))}}></textarea>
                    </td>
                </tr>
            )
        })
    }
    return (
        <div className={`AltTextAudit`}>
            {props.images && props.images.filter(el=> el.src).length > 0 && <table>
                <thead>
                    <tr>
                        <th>Image</th>
                        <th>Alt Text</th>
                    </tr>
                </thead>
                <tbody>
                    {genTableBody()}
                </tbody>
            </table>}
        </div>
    )
}

export default AltTextAudit